import { useGrid } from '@Components/Grid/context';
import { TableResizeProvider } from '@Components/tableResize/context';
import { useInicializeTableResize } from '@Components/tableResize/hooks';

import DefaultTableBody from './Body';
import DefaultTableHeader from './Header';
import TableWrapper from './Wrapper';
import { TableProvider } from './context';
import { PinnedColumnsProvider } from './pinned'

export default function DefaultTable() {
  const { definitions: { enableTableResize = true } } = useGrid()

  return <TableProvider>
    <PinnedColumnsProvider>
      {!enableTableResize ? <DefaultTableContent /> : <>
        <TableResizeProvider>
          <DefaultTableResizeContent />
        </TableResizeProvider>
      </>}
    </PinnedColumnsProvider>
  </TableProvider>
}

function DefaultTableResizeContent() {
  const { visibleColumns } = useGrid()
  const { hadResized, onResize } = useInicializeTableResize({ columns: visibleColumns })

  return <TableWrapper hadResized={hadResized}>
    <DefaultTableHeader onResize={onResize} />
    <DefaultTableBody />
  </TableWrapper>
}

function DefaultTableContent() {
  return <TableWrapper hadResized={false}>
    <DefaultTableHeader />
    <DefaultTableBody />
  </TableWrapper>
}
